module.exports = __webpack_public_path__ + "img/zhilioudianji.prt.8aa00be1.jpg";